import { render, staticRenderFns } from "./EsperaConsulta.vue?vue&type=template&id=ddcf330a&"
import script from "./EsperaConsulta.vue?vue&type=script&lang=js&"
export * from "./EsperaConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports